// Globals
var isDebug = false;
var $ = window.jQuery;

window.checkSession = wp_vars.checkSession;
window.basePath = wp_vars.install;
window.fullBase = wp_vars.home;

function is_int(value) {
  if (parseFloat(value) == parseInt(value) && !isNaN(value)) {
    return true;
  } else {
    return false;
  }
}

function addOverlay(olclass, content, stack=false) {
  if(!stack) $("#overlay, #overlay-stacked").remove();
  else{
      $('#overlay').attr('id','overlay-stacked');
      $('#olWrap').attr('id','olWrap-stacked');
      $('#olClose').attr('id','olClose-stacked');
      $('#olContent').attr('id','olContent-stacked');
      $(document).off('click.confirm-cancel').on('click.confirm-cancel','.confirm-cancel',function(){
          console.log('hi');
          $('#overlay').remove();
          $('#overlay-stacked').attr('id','overlay');
          $('#olWrap-stacked').attr('id','olWrap');
          $('#olClose-stacked').attr('id','olClose');
          $('#olContent-stacked').attr('id','olContent');
      });
  }
  $("#waiting").remove();
  $("body").append('<div id="overlay" class="' + olclass + '"></div>');
  $("#overlay").append('<div id="olWrap">');
  $("#olWrap").append('<div id="olClose">×</div>');
  $("#olWrap").append('<div id="olContent">');
  $("#olContent").append(content);
  //console.log($(window).width());
  if ($(window).width() < 769) {
    $("#overlay").css({
      position: "absolute",
      height: $("body").height(),
    });
  }

}

function addWaiting() {
  $("#waiting").remove();
  $("body").append('<div id="waiting"></div>');
  $("#waiting").append('<i class="fa fa-spinner fa-spin"></i>');
}

function calculateLoan() {
  // Look up the input and output elements in the document
  var amount = document.getElementById("LoanAmount");
  var apr = document.getElementById("Interest");
  var years = document.getElementById("Years");
  var payment = document.getElementById("monthly");
  var total = document.getElementById("total");
  var annual = document.getElementById("Annual");
  var totalinterest = document.getElementById("interestAmt");

  // Get the user's input from the input elements. Assume it is all valid.
  // Convert interest from a percentage to a decimal, and convert from
  // an annual rate to a monthly rate. Convert payment period in years
  // to the number of monthly payments.
  var principal = parseFloat(amount.value.replace(/\D/g, "").replace(/,/g, ""));
  var interest = parseFloat(apr.value) / 100 / 12;
  var payments = parseFloat(years.value) * 12;

  // Now compute the monthly payment figure.
  var x = Math.pow(1 + interest, payments); // Math.pow() computes powers
  var monthly = (principal * x * interest) / (x - 1);

  // If the result is a finite number, the user's input was good and
  // we have meaningful results to display
  if (isFinite(monthly)) {
    // Fill in the output fields, rounding to 2 decimal places
    payment.innerHTML = "$" + monthly.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    document.getElementById("LoanAmount").value = "$" + monthly.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    total.innerHTML = "$" + (monthly * payments).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    totalinterest.innerHTML = "$" + (monthly * payments - principal).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    document.getElementById("yrs").innerHTML = years.value;
    annual.value = monthly * 12;
  } else {
    // Result was Not-a-Number or infinite, which means the input was
    // incomplete or invalid. Clear any previously displayed output.
    payment.innerHTML = "$0"; // Erase the content of these elements
    total.innerHTML = "$0";
    totalinterest.innerHTML = "$0";
    annual.value = 0;
  }
  $.ajax({
    type: "POST",
    url: "/wp-admin/admin-ajax.php",
    data: {
      action: 'fw_update_status',
      section: "pfc-lcc",
      status: "",
      inwp: true,
    },
    success: function (data) {
      //console.log(data);
    },
    error: function () {},
  });
}

function fw_init() {
  "use strict";
  if ($(".college-compare").length) {
    // COLLEGE COMPARISON
    var ht = 0;
    var ct = $("#preferences .accordion").length;
    $("#preferences .accordion").each(function () {
      if ($(this).height() > ht) {
        ht = $(this).height();
      }
      if (!--ct) {
        $(".colBox .box, #preferences .accordion").height(ht);
        $("#preferences").toggleClass("closed");
      }
    });
  }
  if ($("#resume-builder").length && $(window).width() > 768) {
    if ($("#right>div:first-child").height() > $("#left>div:first-child").height()) {
      $("#left>div:first-child").height($("#right>div:first-child").height());
    } else {
      $("#right>div:first-child").height($("#left>div:first-child").height());
    }
    if ($("#right>div:last-child").height() > $("#left>div:last-child").height()) {
      $("#left>div:last-child").height($("#right>div:last-child").height());
    } else {
      $("#right>div:last-child").height($("#left>div:last-child").height());
    }
  }
}

function formatNum(obj) {
  if (obj) {
    // object exist
    var val = obj.value.replace(/\D/g, "");
    if (val != "") {
      obj.value =
        "$" +
        parseFloat(val.replace(/,/g, ""))
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
}

function getAjaxData(data){
  return data;
}


function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}
function decode64(input) {
    var output = "";
    var chr1, chr2, chr3 = "";
    var enc1, enc2, enc3, enc4 = "";
    var i = 0;

    // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
    var base64test = /[^A-Za-z0-9\+\/\=]/g;
    if (base64test.exec(input)) {
        alert("There were invalid base64 characters in the input text.\n" +
            "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
            "Expect errors in decoding.");
    }
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    do {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output = output + String.fromCharCode(chr1);

        if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
        }

        chr1 = chr2 = chr3 = "";
        enc1 = enc2 = enc3 = enc4 = "";

    } while (i < input.length);

    return unescape(output);
}
